<template>
  <div class="ride-public-map">
    <div class="map-wrapper" id="ride-public-map">
      <div :id="mapID" class="map">
        <div class="leaflet-top leaflet-right">
          <div class="center-btn button is-white is-rounded" @click="recenter">
            <i class="fa fa-crosshairs" :class="{ 'fa-spin': spin }" />
          </div>
        </div>
        <div v-if="distanceToBusiness > warningDistance" class="leaflet-bottom">
          <div class="tag is-danger" style="margin: 0 auto" @click="fitToMap">
            {{ $t("ride.you-are-far-from-x", { x: workflow.business.name }) }}
            {{ kmToBusiness }}
          </div>
        </div>
      </div>
    </div>

    <div class="warning">
      <span v-show="warning" class="tag is-danger">
        <i class="fa fa-exclamation-triangle" />
        <span v-html="warning" style="margin-left: 6px" />
      </span>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import geo from "@/geo";
import L from "leaflet";
import "leaflet.awesome-markers";
import vehicles from "@/vehicles";

export default {
  name: "RidePublicMap",
  props: {
    workflow: Object,
  },
  data() {
    return {
      mapID: "ride-public-map-map",
      map: null,
      layer: null, // main layer
      warning: null,
      userMarker: null,
      spin: false,
      //   isFarFromStops: false,
      distanceToBusiness: null,
      warningDistance: 29000,
      popupWide: { closeButton: false, maxWidth: 300, autoPan: false },
      popupNarrow: { closeButton: false, maxWidth: 80, autoPan: false },
      driversMarkers: [], // drivers for observers
      //   vehicleImg: "/img/transport/tuktuk_private.png",
    };
  },
  computed: {
    kmToBusiness() {
      var km = Math.round(this.distanceToBusiness / 1000);
      return `~${km}km`;
    },
    vehicleImg() {
      var iconName = this.workflow.data.icon || this.workflow.name;
      return vehicles.img(iconName);
    },
  },
  mounted() {
    this.initMap();
    this.watchUserLocation();
    this.checkWarning();
    // this.drawTransportStops();
    this.computeDistanceToBusiness();
    this.updateDrivers();
  },
  activated() {
    this.updateUserMarkerLocation();
    // this.updateDrivers();
  },
  methods: {
    fitToMap() {
      var padding = { padding: [50, 50] };
      this.map.fitBounds(this.layer.getBounds(), padding);
      setTimeout(() => this.userMarker.openPopup(), 1000);
    },
    computeDistanceToBusiness() {
      var business = this.workflow.business;
      //   if (this.farAwayFromUser(business, 1000)) {
      //     this.isFarFromStops = true;
      //   } else this.isFarFromStops = false;
      var coords = this.$store.getters.getUserLocation;
      if (!coords) return;
      var userLoc = { lat: coords[0], lon: coords[1] };
      this.distanceToBusiness = geo.distanceToUserInMeters(business, userLoc);
      if (this.distanceToBusiness > this.warningDistance) {
        this.fitToMap();
      }
    },
    checkWarning() {
      // return (this.warning = "Your GPS location is old");
      // check time of last user location, if old prompt update
      var userState = this.$store.state.userState;
      if (!userState) {
        this.warning = "Please grant GPS permission to ride";
        return;
      }
      var updatedAt = new Date(userState.updated_at);
      var minutes = (new Date().getTime() - updatedAt.getTime()) / (1000 * 60);
      if (minutes > 10) this.warning = this.$t("ride.your-gps-is-old");
      else this.warning = null; // GPS is update-to-date
    },
    watchUserLocation() {
      this.$store.subscribe((mutation) => {
        if (mutation.type === "setUserState") {
          // this.updateUserMarkerLocation();
          this.warning = null;
          var coords = this.$store.getters.getUserLatLon;
          this.userMarker.setLatLng(coords);
        }
      });
    },
    recenter() {
      // var coords = this.$store.getters.getUserLocation;
      // this.updateMarkerLocation(coords, true);
      this.spin = true;
      setTimeout(() => (this.spin = false), 600);
      this.updateUserMarkerLocation(true);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      this.map = L.map(this.mapID, { attributionControl: false });
      var coords = this.$store.getters.getUserLatLon;
      this.map.setView(coords, 16);

      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        // minZoom: 12,
        maxZoom: 19,
      }).addTo(this.map);

      this.layer = L.featureGroup().addTo(this.map);

      this.map.zoomControl.remove();
      this.drawUserLocation();

      this.map.on("click", () => {
        this.updateDrivers();
        this.clearTimeout();
      });
      this.map.on("dragstart", () => this.clearTimeout());
      this.map.on("zoomend", () => this.clearTimeout());
    },
    clearTimeout() {
      EventBus.$emit("RIDE_WHERE_TO_CLEAR_TIMEOUT");
    },
    drawUserLocation() {
      var coords = this.$store.getters.getUserLatLon;
      var icon = L.divIcon({
        html: `<div class="blue-dot pulse"></div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
      this.userMarker = L.marker(coords, { icon: icon });
      this.userMarker.addTo(this.layer);
      var popupOpts = { closeButton: false, autoPan: true };
      this.userMarker.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
    },
    // func updates coords and sets view
    updateUserMarkerLocation(flyTo) {
      var coords = this.$store.getters.getUserLatLon;
      this.userMarker.setLatLng(coords);
      if (flyTo) this.map.flyTo(coords);
      // annoying
      else this.map.setView(coords, 17);
    },
    drawTransportStops() {
      var w = this.workflow;
      var dot = L.divIcon({
        html: `<div class='stop'></div>`, // siilor-stop songthaew-stop
        popupAnchor: [3, -6], // [0, -6],
        className: "none",
      });
      var prefix = `<i class="fa fa-map-marker-alt"></i>&nbsp;<span>`;
      var stops = w.data.stops;
      stops.forEach((s) => {
        if (this.farAwayFromUser(s, 1000)) return; // don't draw far away stops
        var text = prefix + `${s.name}</span>`;
        var m = L.marker([s.lat, s.lon], { icon: dot });
        m.addTo(this.layer).bindPopup(text, this.popupWide);
      });
    },
    farAwayFromUser(p, dist) {
      if (this.$store.getters.isSuperUser) return false; // show all drivers to superuser
      if (this.isDispatcher) return false; // show all drivers to dispatcher
      var coords = this.$store.getters.getUserLocation;
      if (!coords) return false;
      var userLoc = { lat: coords[0], lon: coords[1] };
      if (geo.distanceToUserInMeters(p, userLoc) > dist) return true;
      return false;
    },
    updateDrivers() {
      this.$store
        .dispatch("trackDrivers", this.workflow.id)
        .then((driverStates) => this.drawDrivers(driverStates))
        .catch((err) => this.apiError(err)); // err.response.data === "No active workers"
    },
    drawDrivers(drivers) {
      console.log("drivers", drivers);
      if (!drivers || !drivers.length) return; // no drivers to draw
      this.removeDrivers();
      var availableIcon = L.divIcon({
        html: `<div class='driver-circle available'><img src='${this.vehicleImg}' /></div>`,
        popupAnchor: [-5, -20],
        className: "none",
      });
      var busyIcon = L.divIcon({
        html: `<div class='driver-circle busy'><img src='${this.vehicleImg}' /></div>`,
        popupAnchor: [-5, -20],
        className: "none",
      });
      var available = { icon: availableIcon, draggable: true };
      var busy = { icon: busyIcon, draggable: true };

      drivers.forEach((ds) => {
        if (ds.role.role_name === "Dispatcher") return; // skip dispatcher
        if (ds.lat == 0) return; // skip bad driver location
        if (this.farAwayFromUser(ds, 3000)) return;
        var t = (new Date() - new Date(ds.updated_at)) / (1000 * 60); // minutes ago
        if (t < 0) return 0;
        if (t > 240) return; // don't show if older than an hour or 4 hours
        var options = available;
        if (ds.role.data.is_busy) options = busy;
        var m = L.marker([ds.lat, ds.lon], options).addTo(this.layer);
        var name = `<strong>${ds.user.name}</strong>`;
        var text = `${name}<br>${Math.round(t)} mins ago`;
        var content = `<a onclick="selectDriver('${ds.id}')">${text}</a>`;
        if (!this.isSuperUser()) content = `<a>${text}</a>`;
        m.bindPopup(content, this.popupWide);
        this.driversMarkers.push(m);
      });
    },
    removeDrivers() {
      if (!this.driversMarkers.length) return;
      this.driversMarkers.forEach((m) => this.layer.removeLayer(m)); // first remove previous markers
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  /* position: relative; */
  position: absolute;
  /* bottom: 0; */
  top: 0;
  height: calc(100vh - 195px);
  width: 100vw;
  z-index: 0;
}
.map {
  position: relative;
  height: 100%;
  width: 100%;
  /* border: 1px solid lightgrey; */
}
.warning {
  font-weight: 450;
  position: absolute;
  top: 12px;
  width: 100vw;
  text-align: center;
  /* font-size: 0.8em; */
}
.center-btn {
  margin: 10px;
  padding: 0 9px;
  pointer-events: auto;
  /* color: rgb(0, 106, 255); */
  color: grey;
  box-shadow: 0 0 4px grey;
}
.leaflet-bottom {
  margin-bottom: 10px;
  width: 100vw;
  pointer-events: initial;
}
</style>

<style lang="scss">
#ride-public-map-map {
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    color: black;
    font-size: 1.2em;
  }
  .leaflet-popup-content i {
    opacity: 0.8;
    color: rgb(23, 102, 193);
  }
  .blue-dot {
    margin-left: 6px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #2693da;
    opacity: 0.9;
    border: 1px solid #feeaa4b5;
  }
  .available {
    background-color: rgba(159, 255, 155, 0.7);
  }
  .busy {
    background-color: rgba(255, 94, 201, 0.7);
  }
  .driver-circle img {
    height: 24px;
    width: 24px;
    filter: drop-shadow(1px 1px 1px #555);
  }
  .driver-circle {
    height: 32px;
    width: 32px;
    border-radius: 50%;
    padding: 3px;
    transform: translateX(-50%) translateY(-50%);
    filter: drop-shadow(2px 2px 2px #555);
    animation: pulsate-yellow 1.5s 999;
  }
  .pulse {
    animation: pulsate-1 3s ease-out infinite;
  }
  @keyframes pulsate-1 {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 166, 0, 0.7);
    }
    100% {
      box-shadow: 0 0 0 1p cyan;
    }
  }
  @keyframes pulsate-yellow {
    0% {
      box-shadow: 0 0 0 0px yellow;
    }
    100% {
      box-shadow: 0 0 0 4px rgba(255, 255, 0, 0.6);
    }
  }
  .stop {
    height: 18px;
    width: 18px;
    border-radius: 50%;
    filter: drop-shadow(2px 2px 2px #555);
    background-color: magenta;
    opacity: 0.8;
  }
}
</style>